import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Select } from "../partials";
import { groupDealerships, formatGroupLabel, excludeDealerships } from "~/js/utils";

class OffersCardAll extends Component {

    state = {
        dealer: null,
    };

     constructor(props) {
        super(props);
        const finalDealerships = props.finalDealerships;

        this.filters = {
            dealers: {
                field: {
                    onChange: ({dealer}) => {
                        this.setState({dealer});
                    },
                    options: finalDealerships,
                    formatGroupLabel: formatGroupLabel
                },
            },
        }
    };
    render() {
        const { dealer } = this.state;

        let ct, hero;
        
        if (dealer) {
            ct = dealer.data['team-contacts'];
            hero = dealer.data['dealership-hero'];
        }

        return (
            <Fragment>
                <div className="offer-card__all-title">
                    Find your nearest participating dealership
                </div>

                <div className="offer-card__all-select">
                    <Select { ...this.filters.dealers.field } modifiers={['form']}/>
                </div>

                { dealer ?
                <div className="offer-card__item offer-card__item--single">
                    <div className="offer-card__item-h">{dealer.post_title}</div>
                    <div className="offer-card__item-body">
                        <div className="offer-card__address">{hero.street_address}</div>
                        <div className="offer-card__phone">Phone: {ct.sales.phone}</div>
                        <div className="offer-card__email">Email: <a href="mailto:{ct.sales.email}">{ct.sales.email}</a></div>
                    </div>
                </div> : null }
            </Fragment>
        );
    }
}

export default function (el, props) {
    ReactDOM.render(<OffersCardAll {...props} />, el)
}
